export default "__VITE_ASSET__BgcEH0p3__"